import { set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'

export default [set(state`media.keyboard.keys.${props`keyCode`}`, false)]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/modifierKeyUp.js